const enTranslations = {
  translation: {
    menu: {
      items: {
        schedule_test: "Get Covid-19 Tested",
        vax_yes_register: "Get Vaccine Card",
        appointments: "Appointments",
        logout: "Logout",
        dashboard: "Dashboard"
      }
    },
    appointment: {
      auth: {
        intro_text: "Please verify the patient date of birth.",
        button: "Submit"
      },
      card: {
        error: "Sorry, we couldn't find your appointment.",
        error_api: "Couldn't find appointment",
        intro_text: "Your Appointment is confirmed",
        qr_code_disclaimer:
          "You will receive this QR code, and confirmation by text message shortly, please keep that handy. Also make sure to bring a government ID to your appointment for verification.",
        symptoms_disclaimer:
          "If you are exhibiting COVID like symptoms, or have been exposed to a confirmed positive case, please continue following quarantine guidelines.",
        thank_you: "Thank you for booking your test with GoGet, Inc",
        id_disclaimer:
          "Please make sure to arrive for your appointment on time, and have your government issued ID handy.",
        sign_off: "Stay safe and stay well.",
        button_schedule_test: "Schedule another test"
      },
      pay_disclaimer: {
        title: "Cost of Care",
        intro_text: "The total cost of your care is"
      },
      pay_error: {
        title: "Payment Error",
        error: "We're sorry, there was an error processing your payment."
      },
      pending: {
        title: "Pending Appointment",
        intro_text:
          "We found a pending appointment that still requires payment.",
        button_pay_now: "Pay Now",
        button_new_appointment: "New Appointment"
      },
      result: {
        error_api: "Unable to retrieve result",
        error_dob_match: "Date of birth does not match, please try again",
        error_empty: "Couldn't find test result",
        summary_title: "Your test result is:",
        summary_subtitle: "Our lab results confirm that you",
        positive_text: "DO have COVID-19",
        positive_next_step:
          "The virus WAS present in the sample you provided. Isolate in your home for 10 days from the testing date or when you first got sick.  Get others in your home tested as well. Continue to monitor for worsening symptoms for up to 10 days.",
        negative_next_step:
          "The virus was not present in the sample you provided. Please continue to monitor for any symptoms for up to 10 days if you feel you had possible exposure.",
        button_lab_report: "See my lab report",
        button_view_faqs: "View FAQ's",
        faqs_title: "Have more questions, read our FAQ's",
        dob_confirm:
          "Please confirm your date of birth to view your Covid-19 result"
      },
      unavailable: {
        title: "Testing Availability",
        intro_text:
          "All our locations and scheduled tests are now full. Please check back soon for more slots.",
        faqs_title: "Have more questions, read our FAQ's",
        button_view_faqs: "View FAQ's",
        status: "FULL"
      },
      vax_certificate: {
        header_title: "Covid-19 Vaccine Certificate",
        error_api: "There was an error retrieving your certificate.",
        card_title: "Administered by",
        card_subtitle: "Vaccine",
        certification_level: "Level {{level}} Verification Approved",
        error_empty: "No certificate found.",
        add_booster_button: "Add booster",
        booster_added_alert:
          "Please allow 2-3 minutes for your booster to appear on your certificate."
      }
    },
    schedule: {
      group_code_screener: {
        title: "Group Code",
        intro_text: "Do you have a group or location code?",
        secondary_text:
          "If you don't have one, don't worry. Select no and continue registration.",
        options: {
          yes: "Yes, I have a code",
          no: "No, skip this step"
        }
      },
      country_select: {
        intro_text: "Where do you want your appointment to take place?"
      },
      pre_register_success: {
        intro_text: "Thank you for registering",
        secondary_text:
          "You have been added to the waitlist. We will text and email you when we have matched you with a vaccine provider in your area that is accepting appointments.",
        button: "Done"
      },
      pre_register: {
        intro_text: "The easiest way to get vaccinated.",
        secondary_text:
          "<0>Create your account now and get ahead of the vaccine scheduling process.</0> <1>As sites open we will match and automatically notify you of the closest location to confirm your appointment.</1>",
        button: "Enroll Now"
      },
      no_slots: {
        intro_text: "Sorry, we've run out of vaccine slots.",
        secondary_text:
          "Unfortunately all the available vaccination slots have now been filled.",
        button: "Return to dashboard"
      },
      group_code: {
        title: "Group Code",
        intro_text: "Please enter your group or location code",
        form: {
          group_code: {
            label: "Group or location code"
          }
        },
        options: {
          no_code: "I don't have a code"
        }
      },
      is_patient: {
        title: "Who is this for?",
        intro_text: "Who is this for?",
        options: {
          yes: "For me",
          no: "For someone else"
        }
      },
      gender: {
        title: "Gender",
        intro_text: "Please select your gender",
        options: {
          male: "Male",
          female: "Female",
          refuse: "Refuse to self identify"
        }
      },
      covid_19_test_type: {
        intro_text: "Please choose Covid-19 test type",
        available_services: {
          pcr: {
            summary: "Highest accuracy results in approx. 48hrs",
            summary_2: "Gold standard in COVID testing — most sensitive result",
            summary_3: "Resulting time is at least 24 hours in most cases"
          },
          antigen: {
            summary: "Rapid test results within 15-30 mins",
            summary_2:
              "15-30 minutes for results – can help when you have limited time to wait for results, like catching a flight",
            summary_3:
              "Good option to understand if you are currently infectious",
            summary_4: "Great option for those experiencing symptoms"
          }
        },
        recommended: "Recommended",
        error_empty: "No services available at this time",
        no_price: "Price calculated at checkout"
      },
      pregnancy: {
        intro_text:
          "For women: Are you pregnant or is there a chance you could become pregnant during the next month?",
        options: {
          yes: "Yes",
          no: "No"
        },
        disclaimer: {
          intro_text: "Please talk to your Doctor",
          secondary_text:
            "We recommend you speak to your doctor or OBGYN about scheduling a COVID-19 vaccine.",
          button: "Return to Home",
          button_secondary: "Go back"
        }
      },
      allergies: {
        intro_text:
          "Do you have allergies to medications, food, a vaccine component, or latex?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      serious_reaction: {
        intro_text:
          "Have you ever had a serious reaction after receiving a vaccination?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      long_term_health: {
        intro_text:
          "Do you have a long-term health problem with heart disease, lung disease, asthma, kidney disease, metabolic disease (e.g., diabetes), anemia, or other blood disorder?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      immune_system: {
        intro_text:
          "Do you have cancer, leukemia, HIV/AIDS, or any other immune system problem?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      immune_system_medications: {
        intro_text:
          "In the past 3 months, have you taken medications that affect your immune system, such as prednisone, other steroids, or anticancer drugs; drugs for the treatment of rheumatoid arthritis, Crohn’s disease, or psoriasis; or have you had radiation treatments?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      nervous_system: {
        intro_text:
          "Have you had a seizure or a brain or other nervous system problem?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      blood_transfusion: {
        intro_text:
          "During the last 90 days have you received monoclonal antibodies (bamlinvad outpatient infusion) or other transfusions of blood or blood products or been given immune (gamma) globulin or an antiviral drug?",
        options: {
          yes: "Yes",
          no: "No"
        },
        disclaimer: {
          intro_text:
            "We recommend you speak to your physician prior to scheduling an appointment.",
          button: "Return to Home",
          button_secondary: "Go back"
        }
      },
      recent_vaccinations: {
        intro_text: "Have you received any vaccinations in the past 2 weeks?",
        options: {
          yes: "Yes",
          no: "No"
        },
        disclaimer: {
          intro_text:
            "Please wait till it has been more than 2 weeks from your previous vaccine to schedule your COVID-19 Vaccine.",
          button: "Return to Home",
          button_secondary: "Go back"
        }
      },
      race: {
        title: "Race",
        intro_text: "How would you describe yourself?",
        error: "You must choose at least one option",
        options: {
          race_american_indian: "American Indian or Alaska Native",
          race_asian: "Asian",
          race_black: "Black or African American",
          race_white: "White or Caucasian",
          race_hawaiian: "Native Hawaiian or Other Pacific Islander",
          other: "Other"
        }
      },
      ethnicity: {
        title: "Ethnicity",
        intro_text: "Are you of Hispanic, Latino, or Spanish Origin?",
        options: {
          yes: "Yes",
          no: "No"
        }
      },
      symptoms: {
        title: "Symptoms",
        intro_text: "Are you currently experiencing any of these symptoms?",
        options: {
          symptom_fever: "Fever or chills",
          symptom_cough: "Cough",
          symptom_short_breath: "Shortness of breath or difficulty breathing",
          symptom_fatigue: "Fatigue",
          symptom_muscle_body_aches: "Muscle or body aches",
          symptom_headache: "Headache",
          symptom_lack_of_smell: "New loss of taste or smell",
          symptom_sore_throat: "Sore throat",
          symptom_congestion_runny_nose: "Congestion or runny nose",
          symptom_nausea_vomitting: "Nausea or vomiting",
          symptom_diarrhea: "Diarrhea"
        }
      },
      contact_tracing: {
        title: "Contact Tracing",
        intro_text:
          "Have you come into contact with someone who has a lab confirmed Covid-19 result?",
        options: {
          yes: "Yes",
          no: "No or Not Sure"
        }
      },
      public_places: {
        title: "Public Places",
        intro_text:
          "Please select all locations that you have visited in the past 14 days.",
        error: "You must choose at least one",
        options: {
          bars_restaurants_cafes: "Bars/Restaurants/Cafes",
          gas_stations: "Gas Stations/Electric Charging Stations",
          medical_offices: "Medical Offices",
          place_of_work: "Office Building/Place of Work",
          retail_grocery_stores: "Retail/Grocery Stores",
          places_of_worship: "Places of Worship/Community Centers",
          public_parks: "Public Parks",
          other: "Any other public location with more than 5 people",
          none: "None of the above"
        }
      },
      patient_details: {
        title: "Patient Details",
        intro_text: "Who's the patient?",
        secondary_text:
          "Please enter the patient name and date of birth as it appears on their government issued id (driving license or passport)",
        form: {
          first_name: {
            label: "First Name"
          },
          middle_name: {
            label: "Middle Name"
          },
          last_name: {
            label: "Last Name"
          },
          dob: {
            label: "Date of Birth"
          }
        }
      },
      flight_info: {
        intro_text: "Please enter your flight details",
        form: {
          flight_airline: {
            label: "Airline"
          },
          flight_number: {
            label: "Flight Number"
          },
          flight_date: {
            label: "Flight Date"
          },
          flight_origin: {
            label: "Flight Origin"
          },
          flight_destination: {
            label: "Flight Destination"
          }
        }
      },
      patient_address: {
        title: "Patient Address",
        intro_text: "Enter the patient's home address",
        link_manual_address: "Can't find your address?",
        link_address_search: "Search for your address",
        form: {
          country: {
            label: "Country"
          },
          street: {
            label: "Street"
          },
          city: {
            label: "City"
          },
          state: {
            label: "State"
          },
          zip_code: {
            label: "Zip/Postal Code"
          },
          search: {
            label: "Search for your address"
          }
        }
      },
      patient_contact: {
        title: "Email Address",
        intro_text: "And, your email for appointment updates",
        form: {
          email: {
            label: "Email"
          }
        },
        terms:
          "By choosing next, I acknowledge that I have reviewed and electronically agree to the <2>terms and conditions and terms of use policy</2>"
      },
      patient_vitals: {
        title: "Patient Details",
        intro_text: "Now let's confirm a few medical details",
        form: {
          height: {
            label: "Height"
          },
          weight: {
            label: "Weight"
          },
          medications: {
            label: "Taking prescription medications?"
          }
        }
      },
      pre_existing_conditions: {
        title: "Pre-existing Conditions",
        intro_text: "Any pre-existing health conditions?",
        options: {
          heart_disease: "Heart Disease",
          diabetes: "Diabetes",
          respiratory_disease: "Respiratory Diseases (e.g. Asthma or COPD)",
          autoimmune_disease: "Auto-immune Disease",
          other_chronic_disease: "Other Chronic Conditions",
          allergies: "Allergies"
        }
      },
      consent: {
        title: "Consent",
        intro_text: "Do you consent for us to conduct this COVID-19 test?",
        form: {
          full_name: {
            label: "Sign your full name"
          }
        },
        terms:
          "By choosing next, I acknowledge that I have reviewed and electronically agree to the <2>terms and conditions and terms of use policy</2>"
      },
      ggd_teaser: {
        title: "Coming Soon",
        intro_text:
          "We’re making modern healthcare easy to find and use. Get on the waitlist today and receive 60 days free of GoGetDoc.",
        form: {
          waitlist: {
            label: "Yes, I want to join the waitlist for GoGetDoc"
          }
        }
      },
      date: {
        title: "Date",
        intro_text: "Please select your appointment date",
        selected_alert_text: "You selected",
        error: "You must choose a date",
        error_api: "Couldn't get available dates",
        error_empty: "No available dates"
      },
      time: {
        title: "Time",
        intro_text: "Choose your appointment time",
        error: "You must choose a time",
        error_api: "Couldn't get available times",
        error_empty:
          "Sorry, there are no avilable times on this date at the location you chose."
      },
      has_insurance: {
        title: "Health insurance",
        intro_text: "Does the patient have health insurance?",
        secondary_text:
          "There is no cost or copay for this service. However, if you have insurance, we will collect an administration fee from them.",
        options: {
          yes: "Yes",
          no: "No, I attest to not having insurance"
        }
      },
      insurance_card: {
        title: "Scan Health Insurance Card",
        button_retake: "Re-take photo",
        button_skip: "Skip",
        skip_disclaimer:
          "Your Covid-19 tests/vaccinations can be covered by insurance. By selecting skip, you are confirming you don't have insurance."
      },
      insurance_verification: {
        title: "Insurance Verification",
        intro_text: "Please verify your insurance information",
        form: {
          payer: {
            label: "Insurance Company Name",
            no_options_text: "Type your insurance company name"
          },
          member_id: {
            label: "Member ID"
          },
          group_no: {
            label: "Group Number"
          },
          relationship: {
            label: "Subscriber Relationship"
          }
        }
      },
      influenza_consent: {
        title: "Influenza Consent",
        intro_text:
          "I have read or had explained to me the Vaccination information statement about influenza vaccination and I understand the benefits and risks. I request that the influenza vaccination be given to me (or the person named below for whom I am authorized to make this request.)",
        form: {
          full_name: {
            label: "Sign your full name"
          }
        }
      },
      influenza_ineligible: {
        intro_text:
          "Based on your answers to the previous screen, we have determined you are ineligible for a flu vaccine at this time. Please contact your primary care provider.",
        button_continue: "Continue without flu vaccine"
      },
      influenza_screening: {
        title: "Influenza Screening",
        intro_text: "Please answer the questions below:",
        options: {
          egg_allergy: "Do you have a severe allergy to eggs?",
          life_threatening_reaction:
            "Have you ever had a life threatening reaction to the influenza vaccine?",
          guillain_barre_syndrome:
            "Do you have a history of guillain-barré syndrome?",
          severely_ill: "Are you moderately or severely ill today?",
          no: "No",
          yes: "Yes"
        }
      },
      location: {
        title: "Location",
        error: "You must choose a location",
        error_api: "Couldn't get available locations",
        error_empty: "Sorry, we couldn't find any locations near you.",
        results: {
          title: "Testing sites nearby",
          count: "{{count}} results found"
        },
        preselected: {
          title: "All Locations"
        }
      },
      service_selection: {
        title: "Service Selection",
        intro_text: "Select the services you would like to schedule",
        error: "You must choose at least one service",
        error_empty: "No services found."
      },
      covid_19_confirmed_case: {
        intro_text:
          "Have you been personally diagnosed with COVID-19 in the last 10 days?",
        options: {
          yes: "Yes",
          no: "No"
        },
        disclaimer: {
          intro_text: "Please wait to get your COVID-19 Vaccine",
          secondary_text:
            "Based on the answer provided, we recommend you wait until your quarantine period is complete and you show no symptoms for 48 hours before receiving the COVID-19 Vaccine.",
          button: "Go Back"
        }
      },
      time_appointment_one: {
        selected_location: "Vaccination location you selected",
        intro_text: "What time works best?",
        error_empty: "No available times for this date.",
        error_api: "Error loading available times"
      },
      time_appointment_two: {
        selected_location: "Vaccination location you selected",
        alert_text: "Choose date for second vaccination",
        intro_text: "Select date and time for second dose",
        error_empty: "No available times for this date.",
        error_api: "Error loading available times"
      },
      symptoms_vax: {
        intro_text:
          "Are you currently experiencing symptoms such as fever, coughing, or shortness of breath?",
        options: {
          yes: "Yes",
          no: "No"
        },
        disclaimer: {
          intro_text: "COVID-19 Test Recommended",
          secondary_text:
            "Based on the answer provided, we recommend you register for a PCR COVID-19 Test before receiving the COVID-19 Vaccine.",
          button: "Schedule Now",
          button_secondary: "Go back"
        }
      },
      vax_consent: {
        intro_text: "Vaccine Consent",
        secondary_text:
          "I agree that the person named below will receive the vaccine indicated and that this person will have a vaccine put in his or her body to prevent infectious disease(s). I received a copy of the Emergency Use Authorization (EUA) for the COVID-19 vaccine. I know the risks of the diseases these vaccines prevent, and the benefits and risks of the vaccines. I have had a chance to ask questions about the diseases, the vaccines, and how the vaccines are given (CDC vaccine information sheet). I am an adult who can legally consent for the person named below to get vaccines. I freely and voluntarily give my signed permission for these vaccines to be given.",
        form: {
          full_name: {
            label: "Sign your full name"
          }
        },
        guardian: {
          intro_text: "Parent/Guardian Vaccine Consent",
          secondary_text:
            "I agree that the person named below will receive the vaccine indicated and that this person will have a vaccine put in his or her body to prevent infectious disease(s). I received a copy of the Emergency Use Authorization (EUA) for the COVID-19 vaccine. I know the risks of the diseases these vaccines prevent, and the benefits and risks of the vaccines. I have had a chance to ask questions about the diseases, the vaccines, and how the vaccines are given (CDC vaccine information sheet). I am an adult who can legally consent for the person named below to get vaccines. I freely and voluntarily give my signed permission for these vaccines to be given."
        }
      },
      occupation: {
        main_intro_text:
          "Do you either attend, work, or volunteer at a school?",
        yes: "Yes",
        no: "No",
        intro_text: "Occupation details",
        secondary_text: "Please enter your occupation details below.",
        intro_text_school: "School details",
        secondary_text_school: "Please enter your school information below.",
        not_employed:
          "I verify that I am not currently employed or enrolled in school",
        form: {
          occupation: "Occupation",
          empolyer_name: "Employer name",
          work_address: "Work address",
          employer_phone: "Employer phone number"
        },
        form_school: {
          school_name: "Name of school",
          role: "Role",
          role_options: {
            faculty: "Faculty",
            staff: "Staff",
            student: "Student"
          },
          location: "Location of school"
        },
        back_button: "Back"
      }
    },
    dashboard: {
      title: "Dashboard",
      error_api: "An error occured.",
      error_empty: "You have no appointments.",
      button_new_test: "<0>Get</0><1>Covid-19 Tested</1>",
      button_new_vax: "<0>Get</0><1>Vaccine Card</1>",
      appointments_title: "Appointments",
      certificates_title: "Certificates",
      certificates_empty: "You have no certificates."
    },
    chat: {
      intro_text: "Chat with Support",
      form: {
        display_name: {
          label: "Enter your name"
        }
      },
      button_start: "Start Chat",
      teaser_text: "Want to talk to a human, ",
      teaser_text_vaxyes: "You’ve got questions? We have answers. ",
      teaser_button: "we're here",
      teaser_button_vaxyes: "FAQ",
      teaser_button_url: "https://help.gogetdoc.com/en/"
    },
    auth: {
      login: {
        intro_text: "Get started by entering your cell phone number.",
        secondary_text:
          "We'll use this number to communicate with you and give you access to your records.",
        form: {
          phone_number: {
            label: "Phone Number"
          },
          has_sms: {
            label: "Can this phone accept SMS?"
          },
          dob: {
            label: "Date of Birth",
            error: {
              required: "Date of birth is required",
              invalid: "Date of birth is invalid"
            }
          },
          first_name: {
            label: "First name"
          },
          last_name: {
            label: "Last name"
          }
        },
        termsGGV:
          'By clicking "next", you agree to GoGet, Inc <2>Terms of Service</2> and acknowledge you have read the <6>Privacy Policy</6>. You also consent to receive calls or SMS messages, including by automated dialer, from GoGet, Inc and its affiliates to the number you provide for informational purposes including your appointments and results. I hereby attest under the penalties of perjury that I was, or will be, fully vaccinated for COVID-19 with an FDA- or WHO-authorized vaccine - meaning that two weeks had passed, or will have passed, since my final dose of the authorized vaccine - at this time. A handling fee may apply for international users. You understand that you may opt out by texting <9>STOP</9> to 877-280-2151',
        termsGGT:
          'By clicking "next", you agree to GoGet, Inc <2>Terms of Service</2> and acknowledge you have read the <6>Privacy Policy</6>. You also consent to receive calls or SMS messages, including by automated dialer, from GoGet, Inc and its affiliates to the number you provide for informational purposes including your appointments and results. A handling fee may apply for international users. You understand that you may opt out by texting <9>STOP</9> to 877-280-2151',

        button: "Log In",
        error_api: "Unable to process your request"
      },
      two_factor: {
        form: {
          code: {
            label: "Verification code"
          }
        },
        button: "Verify",
        button_resend: "Request another code",
        code_by_phone:
          "We are now calling <1>{{phone}}</1> to provide your authentication code. Please wait one moment while we connect the call."
      },
      verify: {
        intro_text: "Please verify the patient information",
        button: "Confirm",
        error_api: "An error occured"
      }
    },
    partner_redirect: {
      disclaimer:
        "You are now being transfering to our approved and trusted partner, GoGetTested.com, to book your appointment"
    },
    components: {
      covid19_test_card: {
        title: "Covid-19 Test",
        appointment_id: "Appointment ID",
        status: "Status",
        result: "View Result",
        confirmation: "Confirmation",
        complete_payment: "Complete Payment"
      },
      covid19_vaccine_card: {
        dose: "Dose {{dose}} of {{doses}}",
        button_confirm: "Confirmation",
        button_certificate: "Certificate",
        title: "Covid-19 Vaccine"
      },
      patient_details: {
        date_of_birth: "Date of Birth"
      },
      loader: {
        title: "Loading",
        intro_text: "Things are taking a little longer than usual.",
        no_refresh_text: "Please do not refresh your browser."
      },
      location_card: {
        selected: {
          title: "Selected location"
        },
        operated_by: "Operated by",
        stats: {
          test_slots: {
            label: "Test Slots"
          },
          time_to_results: {
            label: "Time to Results"
          },
          test_wait_time: {
            label: "Test Wait Time"
          }
        },
        button: {
          selected: "Selected",
          unselected: "Select this location"
        }
      },
      location_card_compact: {
        selected: {
          title: "Selected location"
        },
        operated_by: "Operated by",
        stats: {
          test_slots: {
            label: "Appointments Available"
          },
          starting_at: {
            label: "Starting at"
          }
        },
        button: {
          selected: "Selected",
          unselected: "Select this location"
        }
      },
      mapbox_location_autocomplete: {
        form: {
          address: {
            label: "Search for your location"
          }
        }
      },
      location_services_list: {
        title: "Services"
      },
      admin_patient_card: {
        registered_on: "Registered on",
        menu: {
          items: {
            appointment: "Appointment",
            contact: "Contact",
            test_result: "Test Result",
            vitals_demographics: "Vitals & Demographics",
            pre_existing_conditions: "Pre-existing Conditions",
            symptoms: "Symptoms",
            billing: "Billing",
            activity_history: "Activity/Contact History"
          }
        }
      },
      test_status_chip: {
        pending: "Pending",
        positive: "Positive",
        negative: "Negative",
        with_lab: "With Lab",
        canceled: "Canceled"
      },
      vax_yes_teaser: {
        teaser_text: "Get your free, secure, verified vaccine card",
        button: "Find out more"
      },
      vax_yes: {
        booster_type_register_form: {
          brand_input_label: "Brand",
          brand_label: "Brand",
          brand_label_none: "None Selected",
          dose_text: "Please confirm the date and lot number for your booster.",
          dose_label: "Lot Number",
          booster_date_label: "Booster Date"
        },
        vaccine_type_register_form: {
          brand_input_label: "Brand",
          brand_label: "Brand",
          brand_label_none: "None Selected",
          dose_text: "Please confirm the date and lot number of each dose.",
          dose_title: "Dose {{dose}}",
          dose_label: "Lot Number (Dose {{dose}})",
          vaccination_date_label: "Vaccination Date (Dose {{dose}})"
        },
        patient_details_register_form: {
          first_name_label: "First Name",
          last_name_label: "Last Name",
          dob_label: "Date of Birth"
        }
      },
      image_upload: {
        upload_error: "Error uploading image",
        upload_new_image: "Upload new image",
        file_size_error: "Your file size is too big"
      }
    },
    common: {
      next: "Next",
      confirm: "Confirm",
      error: "Sorry, an error occured",
      page_not_found: "Sorry, we couldn't find that page",
      go_home: "Go to dashboard",
      learn_more: "Learn More",
      continue: "Continue",
      total: "Total"
    },
    vax_yes: {
      vax_yes_booster_success: {
        intro_text: "Thank you, {{first_name}}!",
        secondary_text: "Your booster record has successfully been added.",
        review_text:
          "Our team is reviewing your request now. You’ll receive a link to access your digital vaccine booster certificate shortly. Share this unique link with family and friends so they can get their digital cards too:",
        share_link_text: "Or share on:",
        button_next: "Return to Dashboard"
      },
      vax_yes_booster_vaccine_card: {
        intro_text: "Please provide an image of your booster vaccine card.",
        secondary_text: "Make sure that the entire card is visible.",
        retake_photo: "Re-take photo",
        button_next: "Next",
        upload_image_text: "Prefer to",
        upload_image_link: "upload an image?",
        take_photo_text: "Prefer to",
        take_photo_link: "take a photo?",
        button_upload_label: "Choose image"
      },
      vax_yes_booster_vaccine_type: {
        intro_text: "Which brand of booster vaccine did you receive?",
        button_next: "Submit"
      },
      vax_yes_register: {
        intro_text: "Get your free, secure, verified vaccine pass",
        intro_text_non_us: "Get your secure, verified vaccine pass",
        secondary_text:
          "Congrats, you got the Covid-19 vaccine. Now save a secure record on your phone for free with VaxYes. In a few easy steps you can get a secure, digital vaccine record that you can use for travel, live shows, and employers.",
        secondary_text_non_us:
          "Congrats, you got the Covid-19 vaccine. Now save a secure record on your phone with VaxYes. In a few easy steps you can get a secure, digital vaccine record that you can use for travel, live shows, and employers.",
        button: "Next"
      },
      vax_yes_register_payment: {
        intro_text: "Choose your own contribution",
        secondary_text_us:
          "VaxYes is a free service for our members. We trust that if we bring you value, you will support us fairly.",
        contribution_text_us: "Most people contribute $2.",
        secondary_text_non_us:
          "VaxYes is a service for our members. We trust that if we bring you value, you will support us fairly.",
        error_message: "We could not initiate your payment. Please try again.",
        api_payment_error:
          "There was an error sending your payment request (API error)",
        button: "Next"
      },
      vax_yes_register_payment_callback: {
        api_payment_processing_error:
          "There was an error processing your payment",
        api_payment_validation_error: "We could not validate your payment"
      },
      vax_yes_register_step: {
        button_back: "Back",
        progress: "Step {{current}} of {{total}}",
        invalid_page: "Invalid page",
        error_api: "There was an issue submitting your data"
      },
      vax_yes_register_photo_id: {
        intro_text:
          "Please provide an image of your government issued photo ID",
        secondary_text:
          "A driver's license works well. Make sure the ID is visible and in focus.",
        retake_photo: "Re-take photo",
        button_next: "Next",
        upload_image_text: "Prefer to",
        upload_image_link: "upload an image?",
        take_photo_text: "Prefer to",
        take_photo_link: "take a photo?",
        button_upload_label: "Choose image"
      },
      vax_yes_register_vaccine_card: {
        intro_text: "Please provide an image of your vaccine card",
        secondary_text: "Make sure the entire card is visible.",
        retake_photo: "Re-take photo",
        button_next: "Next",
        upload_image_text: "Prefer to",
        upload_image_link: "upload an image?",
        take_photo_text: "Prefer to",
        take_photo_link: "take a photo?",
        button_upload_label: "Choose image"
      },
      vax_yes_register_vaccine_type: {
        intro_text: "Which brand of vaccine did you receive?",
        button_next: "Next"
      },
      vax_yes_register_id_scan: {
        intro_text:
          "Please scan the barcode on the back of your driving license",
        skip_text: "Trouble scanning barcode?",
        button_skip: "Skip",
        verify_intro_text:
          "Please verify your first name, last name and date of birth",
        button_scan: "Scan Government ID",
        button_next: "Next"
      },
      vax_yes_register_contact: {
        intro_text: "Please provide your email address.",
        secondary_text: "We'll use this to notify you when your card is ready.",
        form_label: "Email",
        button_next: "Next"
      },
      vax_yes_register_success: {
        intro_text: "Thank you, {{first_name}}!",
        secondary_text:
          "Your vax card registration was successful. Our team is reviewing your request now. You'll receive a link to access your digital vaccine certificate shortly.",
        share_text:
          "Share this unique link with family and friends so they can get their digital cards too:",
        share_link_text: "Or share on:",
        button_next: "Return to Dashboard"
      },
      vax_yes_verify: {
        intro_text:
          "Please enter the member’s date of birth to verify VaxYes verification level",
        button_text: "Submit"
      }
    }
  }
};

export { enTranslations };
